//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { Box, setRef, Tooltip } from "@mui/material";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Modal, ModalBody } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as Info } from "../../assets/info.svg";
import {
  disableEvidenceStatesEndPoint,
  enableEvidenceStatesEndPoint,
  fetchCameraDevicesEndPoint,
  fetchDiscoveredCamerasEndPointByCompanion,
  getEvidenceStatesEndPoint,
  pairCameraEndPoint,
  unpairCameraEndPoint
} from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import CompanionDeviceDetailsTable from "../../global/components/Tables/CompanionDeviceDetailsTable";
import useFetch from "../../global/hooks/useFetchHooks";
import GmtToLocal from "../../global/utility/GmtToLocal";
import { hasPermission } from "../../global/utility/permissionUtils";
import { sortAndSetAlertList } from "../../global/utility/tableUtils";
import {
  Base64ImageDecoder,
  Base64VideoDecoder,
  fetchEvidenceDetails,
  getIncidentsData,
  getResourceIdentifierForDevice,
  isItGateway,
  setDeviceTypeNickName
} from "../../global/utility/Utils";
import { showNotificationBanner } from "../../store/actions";
import "../../styles/deviceStyle.css";
import CompanionOnboardingModal from "../Devices/Campanion/CompanionOnboardingModal";
import ResetCredsModal from "../Devices/Campanion/ResetCredsModal";
import NewCameraTab from "../Devices/NewDevices/newCameraTab";
import ErrorTemplate from "../../global/components/errorTemplate/ErrorTemplate";
import { Loader } from "@vds/loaders";
import { TEXT } from "../../global/constants/errorTemplateConstants";
import { pageTypes } from "../../global/constants/pageTypes";
import { DEVICE_STATUS_DISPLAY, FW_UPGRADE_STATE } from "../../global/constants/tableConstants";
import { QUERY_PARAMS, ROUTES } from "../../global/constants/routesConstants";
import { COMPANION_OFFLINE_NOTIFICATION, DEVICE_CONSTANTS } from "../../constants/DeviceConstants";

const CompanionDeviceInfo = () => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const companionCameraDevicesdata = useSelector((state) => state.deviceReducer);
  const companionDeviceList = useSelector((state) => state.deviceReducer.companionDeviceList);
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const ccdUpdateList = useSelector((state) => state.deviceReducer.ccdUpdateList);
  const navigate = useNavigate();

  const [stateData, setStateData] = useState(state?.data || {});
  const [deviceNotFound, setDeviceNotFound] = useState(false);
  const [tableRow, setTableRow] = useState([]);
  const [showEditDevice, setShowEditDevice] = useState(false);
  const [camerasList, setCamerasList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [cameraSelected, setCameraSelected] = useState("");
  const [loadAssociateCamera, setLoadAssociatedCamera] = useState(false);
  const [associateCameraLoading, setAssociateCemaraLoading] = useState(true);
  const [incidentList, setIncidentList] = useState([]);
  const [evidenceid, setEvidenceid] = useState("");
  const [apiLoading, setApiLoading] = useState({
    incidentTable: false,
    discoverTable: false
  });
  const [discoverTableData, setDiscoverTableData] = useState([]);
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);
  const [deviceTagsList, setDeviceTagsList] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState([]);
  const [showCompanionModal, setShowCompanionModal] = useState(false);
  const [showResetCompanionModal, setShowResetCompanionModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [evidenceImage, setEvidenceImage] = useState({
    mediaType: "",
    mediaUrl: ""
  });
  const [apiError, setApiError] = useState(false);
  const dispatch = useDispatch();

  const buildCcdFields = (ccdUpdate) => {
    const eta = ccdUpdate?.fields?.fw_eta_state_upgrade;
    const fwState = ccdUpdate?.fields?.fw_state_upgrade;
    if (eta === 0 && fwState?.toLowerCase() === FW_UPGRADE_STATE.SUCCESS) {
      return { connectivityStatus: DEVICE_STATUS_DISPLAY.ONLINE, ETA: null };
    }
    if (eta && fwState?.toLowerCase() === FW_UPGRADE_STATE.INPROGRESS) {
      return { connectivityStatus: FW_UPGRADE_STATE.INPROGRESS, ETA: eta };
    }
    return {};
  };


  const {
    data: list,
    loading,
    error
  } = useFetch(
    fetchCameraDevicesEndPoint(),
    {
      method: "POST",
      body: JSON.stringify({
        accountname: activeSession.accountId,
        id: stateData?.uid
      })
    },
    [loadAssociateCamera],
    setAssociateCemaraLoading
  );

  // useEffect(() => {
  //   setStateData(
  //     companionCameraDevicesdata.companionDeviceList.find(
  //       (f) => f.id == state.data.id
  //     )
  //   );
  // }, [companionCameraDevicesdata]);

  // useEffect(() => {
  //   setTableLoading(associateCameraLoading);
  // }, [associateCameraLoading]);

  useEffect(() => {
    setDeviceTagsList(stateData?.tagids || []);
  }, [state]);

  useEffect(() => {
    setTableLoading(false);

    if (error) {
      setApiError(true);
    }
    console.log(error);
  }, [error]);

  useEffect(() => {
    if (list && list.length > 0) {
      setApiError(false);

      for (let i = 0; i < list.length; i++) {
        list[i] = {
          ...list[i],
          ...setDeviceTypeNickName(list[i], stateData || {})
        };
      }
      let filterList = list.filter((device) => {
        if (device.parentdeviceid === stateData?.uid) {
          return true;
        } else {
          return false;
        }
      });

      const allCameras = list.filter((device) => {
        return !isItGateway(device);
      });

      const { kind = "" } = stateData || {};
      for (let i = 0; i < filterList.length; i++) {
        let sensorDetail = {};
        if (kind.includes("lorawan")) {
          sensorDetail.nickname = "LoRa Sensor";
        } else if (kind.includes("iokey")) {
          sensorDetail.nickname = "IOKey Sensor";
        } else if (kind.includes("ts.device.tgAssetTracker")) {
          sensorDetail.nickname = "BLE Sensor";
        } else if (kind.includes("ts.device.gateway.vision.companion")) {
          sensorDetail.nickname = "Camera";
        }
        filterList[i] = { ...filterList[i], ...sensorDetail };
      }
      setTableRow(filterList);
      setCamerasList(allCameras);
    } else {
      setTableRow([]);
    }
  }, [list, stateData]);

  // const editButtonOnClick = (show, name, location) => {
  //   if (name !== "") state.data.name = name;
  //   if (location !== "") updateCustomData(location);
  //   setShowEditDevice(show);
  //   // refreshAllDeviceList();
  // };

  const loadDiscoverTableData = async () => {
    try {
      const resourceidentifier = getResourceIdentifierForDevice(stateData || {});

      setApiLoading((prev) => ({ ...prev, discoverTable: true }));
      setDiscoverTableData([]);
      const response = await axiosInstance.post(fetchDiscoveredCamerasEndPointByCompanion(), {
        accountname: activeSession.accountId,
        resourceidentifier: resourceidentifier,
        forcediscovery: true
      });
      const data = response.data;
      const status = response.status;

      const outputArray = data.map((obj) => ({
        ...obj,
        images: obj.fov.map((item) => `data:image/png;base64,${item.snapshot}`)
      }));
      setDiscoverTableData(outputArray);
      setApiLoading((prev) => ({ ...prev, discoverTable: false }));
    } catch (e) {
      console.log(e);
      setApiLoading((prev) => ({ ...prev, discoverTable: false }));
    }
  };
  // commenting as we dont need incidents in camera detail
  // useEffect(() => {
  //   callIncidentApi();
  // }, [fetchIncidents]);

  // commenting as discovered cameras is moved to seperate Tab and evident status is not required
  // useEffect(() => {
  //   getEvidentStatus();
  //   loadDiscoverTableData();
  // }, []);

  // No router state and no ccdId param → nothing to show, go back to devices
  useEffect(() => {
    if (!stateData?.id && !searchParams.get(QUERY_PARAMS.CCD_ID)) {
      navigate(ROUTES.DEVICES);
    }
  }, []); 

  // Handle deep-link: when no router state, load device from companionDeviceList via ccdId query param
  useEffect(() => {
    if (!stateData?.id && companionDeviceList?.length > 0) {
      const ccdId = searchParams.get(QUERY_PARAMS.CCD_ID);
      if (ccdId) {
        const device = companionDeviceList.find((d) => d.id === ccdId);
        if (device) {
          if (device?.fields?.connectivityStatus?.toLowerCase() !== DEVICE_CONSTANTS.CCD_ONLINE_STATUS) {
            dispatch(showNotificationBanner(COMPANION_OFFLINE_NOTIFICATION));
            navigate(ROUTES.DEVICES);
          } else {
            setStateData(device);
          }
        } else {
          setDeviceNotFound(true);
        }
      }
    }
  }, []);

  // Sync stateData when companionDeviceList or ccdUpdateList updates
  useEffect(() => {
    if (companionDeviceList && stateData?.id) {
      const updatedDevice = companionDeviceList.find((device) => device.id === stateData.id);
      if (updatedDevice) {
        const ccdUpdate = Array.isArray(ccdUpdateList) ? ccdUpdateList.find((ccd) => ccd.id === stateData.id) : null;
        const ccdFields = buildCcdFields(ccdUpdate);
        setStateData((prevState) => ({
          ...prevState,
          ...updatedDevice,
          softwareversion: ccdUpdate?.fields?.ccdversion ?? updatedDevice.softwareversion,
          fields: {
            ...prevState?.fields,
            ...updatedDevice?.fields,
            ...ccdFields,
          },
        }));
      }
    }
  }, [companionDeviceList, ccdUpdateList]);

  useEffect(() => {
    if (evidenceImage.mediaUrl) {
      setShowEvidenceModal(true);
    }
  }, [evidenceImage]);

  const updateEvidenceStateOfCCD = async (e) => {
    console.log(e);
    var notificationInfo = {
      type: "Companion Devices Evidence Status Update",
      showNotification: true
    };
    const aPIEndPoint = e == "enable" ? enableEvidenceStatesEndPoint() : disableEvidenceStatesEndPoint();
    const deviceRefid = stateData[stateData?.refidtype];
    try {
      const response = await axiosInstance.post(aPIEndPoint, {
        accountname: activeSession.accountId,
        resourceidentifier: { qrcode: deviceRefid }
      });
      const evidanceRes = response.data;
      if (response.status == 200) {
        notificationInfo = {
          type: "Companion Devices Evidence Status Updated",
          priority: "success",
          title: stateData?.name + " evidence status " + e + "d",
          showNotification: true
        };
      } else {
        notificationInfo = {
          type: "Companion Devices Evidence Status Update",
          priority: "success",
          title: "Some error occured!",
          showNotification: true
        };
      }
    } catch (e) {
      console.log(e);
      notificationInfo = {
        type: "Companion Devices Evidence Status Update",
        priority: "success",
        title: "Some error occured!",
        showNotification: true
      };
      return;
    } finally {
      dispatch(showNotificationBanner(notificationInfo));
    }
  };

  const handleOpenModal = (id) => {
    console.log({ id });
    if (!hasPermission("Companions", "Edit")) {
      showPermissionsBanner();
    } else {
      setSelectedRowId(id);
      setShowCompanionModal(true);
    }
  };

  const handleResetModal = (id) => {
    if (!hasPermission("Companions", "Edit")) {
      showPermissionsBanner();
    } else {
      setSelectedRowId(id);
      setShowResetCompanionModal(true);
    }
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const tooltipContent = (
    <div style={{ backgroundColor: "white", padding: "5px", width: "224px" }}>
      <div style={{ padding: "5px 0 15px 0" }}>
        <Body viewport="desktop" size="small" bold={true}>
          {" "}
          Serial number{" "}
        </Body>
        <div style={{ paddingTop: "5px" }}>
          <Body>{stateData?.serial ? stateData?.serial : "-"}</Body>
        </div>
      </div>
      <div style={{ padding: "5px 0 15px 0" }}>
        <Body viewport="desktop" size="small" bold={true}>
          {" "}
          Make{" "}
        </Body>
        <div style={{ paddingTop: "5px" }}>
          <Body>{stateData?.manufacturer ? stateData?.manufacturer : "-"}</Body>
        </div>
      </div>
      <div style={{ padding: "5px 0 15px 0" }}>
        <Body viewport="desktop" size="small" bold={true}>
          {" "}
          Model{" "}
        </Body>
        <div style={{ paddingTop: "5px" }}>
          <Body>{stateData?.productmodel ? stateData?.productmodel : "-"}</Body>
        </div>
      </div>
    </div>
  );

  if (deviceNotFound) {
    return (
      <Box sx={{ height: "500px" }}>
        <ErrorTemplate title={TEXT.CCD_NOT_FOUND_ERROR} description={TEXT.CCD_NOT_FOUND_DESC} onRefresh={() => navigate(ROUTES.DEVICES)} />
      </Box>
    );
  }

  return (
    <>
      <Breadcrumbs surface="light">
        <BreadcrumbItem>
          <Link data-testid="companionDeviceInfo_devicesLink" to="/devices" state={{ tabName: "Companion Devices" }} className="breadcrums-item_link">
            Companion Devices
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>Companion Devices Details</BreadcrumbItem>
      </Breadcrumbs>
      <div className="companion-device-header">
        <div className="companion-device-title-group">
          <Title viewport="desktop" size="large">
            {stateData?.name}
            <Tooltip
              placement="bottom"
              arrow
              title={tooltipContent}
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    border: "1px solid black",
                    "& .MuiTooltip-arrow": {
                      backgroundColor: "white"
                    }
                  }
                }
              }}
            >
              <sup>
                {" "}
                <Info />{" "}
              </sup>
            </Tooltip>
          </Title>
        </div>
        <div className="companion-device-header-actions">
          <Button size="large" use="primary" width="auto" data-testid="companionDeviceInfo_editDetailsButton" onClick={() => handleOpenModal(stateData?.refid)}>
            Edit details
          </Button>
          <Button
            size="large"
            use="secondary"
            width="auto"
            data-testid="companionDeviceInfo_resetCameraCredsButton"
            onClick={() => handleResetModal(stateData?.refid)}
          >
            Reset camera credentials
          </Button>
        </div>
      </div>
      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        opened={showEditDevice}
        disableOutsideClick={true}
        hideCloseButton={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px"
            }}
            data-testid="companionDeviceInfo_closeIconButton"
            onClick={() => {
              setShowEditDevice(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        {/* <EditDevice
          deviceInfo={state.data}
          setShowEditDevice={editButtonOnClick}
          deviceTagsList={deviceTagsList}
          setDeviceTagsList={setDeviceTagsList}
        /> */}
      </Modal>
      <CompanionDeviceDetailsTable
        companionDeviceData={stateData || {}}
        setShowEditDevice={setShowEditDevice}
        updateEvidenceStateOfCCD={updateEvidenceStateOfCCD}
        //isCloudStorageDevice = {isCloudStorageDevice}
      />
      {!associateCameraLoading && !apiError && (
        <div className="assosi_table">
          <NewCameraTab
            cameraData={companionCameraDevicesdata}
            pageName={pageTypes.COMPANION_DEVICE_INFO}
            parentDeviceId={stateData?.id}
            companionSiteId={stateData?.siteids?.length > 0 ? stateData.siteids[0] : null}
          />
        </div>
      )}
      {!associateCameraLoading && apiError && (
        <Box sx={{ height: "200px" }}>
          <ErrorTemplate
            title={TEXT.ASSOCIATED_CAMERA_ERROR}
            description={TEXT.ASSOCIATED_CAMERA_DESC}
            testId="error_assoc_table"
            onRefresh={() => setLoadAssociatedCamera((prev) => !prev)}
          />
        </Box>
      )}
      {associateCameraLoading && (
        <Box sx={{ height: "200px", position: "relative" }}>
          <Loader active={associateCameraLoading} fullscreen={false} />
        </Box>
      )}
      <CompanionOnboardingModal
        title="Companion device details"
        showModal={showCompanionModal}
        setShowModal={setShowCompanionModal}
        selectedRowId={selectedRowId}
        type={"companionInfoPage"}
        eventVideoStatus={stateData?.customdata?.cansendmedia}
      />
      {showResetCompanionModal && (
        <ResetCredsModal
          title="Companion device details"
          showModal={showResetCompanionModal}
          setShowModal={setShowResetCompanionModal}
          selectedRowId={selectedRowId}
        />
      )}
      <br />
      <br />
      <br />
    </>
  );
};

export default CompanionDeviceInfo;
